"use client";

import { LoadingSpinner } from "@cmp-src/loadings/LoadingSpinner";
import { Button } from "@cmp-src/primitives/button";
import { isTacticStaff } from "@gettactic/helpers/src/user/isTacticStaff";
import Link from "next/link";
import React from "react";
import { SetupModernBox } from "@/features/setup/components/SetupModernBox";
import { useSetupCheckAuthenticated } from "@/features/setup/hooks/useSetupCheckAuthenticated";

export const SetupChooseYourDestiny: React.FC = () => {
  const basicUser = useSetupCheckAuthenticated();
  const canCreateOrganization = !!isTacticStaff({
    user: basicUser.data ?? null
  });

  return (
    <div className={"tactic-setup-page"}>
      <SetupModernBox>
        {basicUser?.isLoading ? (
          <div className="mt-24 flex justify-center">
            <LoadingSpinner color="text-white" />
          </div>
        ) : (
          <>
            <div className={"flex flex-col gap-2"}>
              <h2 className="my-4 text-center font-bold text-4xl text-secondary-foreground">
                Welcome!
              </h2>
              <p className="text-center">
                You have successfully created a Tactic account. <br />
                {canCreateOrganization ? "Please choose an option below." : ""}
              </p>
            </div>
            <div className="mt-8 w-full justify-center">
              <div className="flex flex-col space-y-4">
                {canCreateOrganization && (
                  <>
                    <Link
                      href="/setup/organization"
                      className={"flex justify-center"}
                    >
                      <Button
                        className="flex w-full items-center justify-center space-x-4 sm:w-auto"
                        size="lg"
                      >
                        <span className="font-normal text-xl">
                          Create new organization
                        </span>
                      </Button>
                    </Link>
                    <div className="flex items-center justify-center space-x-6">
                      <div className="h-px w-1/2 bg-gray-200" />
                      <span className="text-neutral-700">OR</span>
                      <div className="h-px w-1/2 bg-gray-200" />
                    </div>
                  </>
                )}
                <Link href="/setup/join" className={"flex justify-center"}>
                  <Button
                    className="flex w-full items-center justify-center space-x-4 sm:w-auto"
                    size="lg"
                  >
                    <span className="font-normal text-xl">
                      Join existing organization
                    </span>
                  </Button>
                </Link>
              </div>
            </div>
          </>
        )}
      </SetupModernBox>
    </div>
  );
};
